(() => {
  if (customElements.get('epk-cart-sepa')) return;
  const normalize = value => value.replace(/\s/g, '').toUpperCase();
  function validIban(value) {
    const iban = normalize(value);
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
    // Country lengths for the SEPA countries supported by this form.
    const lengths = {AD:24,AL:28,AT:20,BE:16,BG:22,CH:21,CY:28,CZ:24,DE:22,DK:18,EE:20,ES:24,FI:18,FR:27,GB:22,GI:23,GR:27,HR:21,HU:28,IE:22,IS:26,IT:27,LI:21,LT:20,LU:20,LV:21,MC:27,MD:24,ME:22,MK:19,MT:31,NL:18,NO:15,PL:28,PT:25,RO:24,RS:22,SE:24,SI:19,SK:24,SM:27,VA:22};
    if (lengths[iban.slice(0, 2)] !== iban.length) return false;
    let remainder = 0;
    for (const char of iban.slice(4) + iban.slice(0, 4)) {
      const digits = /[A-Z]/.test(char) ? String(char.charCodeAt(0) - 55) : char;
      for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
    }
    return remainder === 1;
  }
  let state;
  let busy = false;
  class SepaCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.fields = Object.fromEntries([...this.querySelectorAll('[data-sepa-field]')].map(el => [el.dataset.sepaField, el]));
      if (!state) state = {enabled: this.dataset.enabled === 'true', holder: this.dataset.holder || '', iban: this.dataset.iban || '', consent: false};
      this.addEventListener('input', () => {
        state = {enabled: this.fields.enabled.checked, holder: this.fields.holder.value, iban: this.fields.iban.value, consent: this.fields.consent.checked};
        this.querySelector('[role="alert"]').textContent = '';
        Object.values(this.fields).forEach(el => el.setCustomValidity(''));
        document.querySelectorAll('epk-cart-sepa').forEach(el => el.render());
      });
      this.render();
    }
    render() {
      if (!this.fields) return;
      for (const key of ['enabled', 'consent']) this.fields[key].checked = state[key];
      for (const key of ['holder', 'iban']) this.fields[key].value = state[key];
      this.querySelector('[data-sepa-details]').hidden = !state.enabled;
    }
    validate() {
      if (!state.enabled) return true;
      let key, message;
      if (!state.holder.trim()) { key = 'holder'; message = 'Bitte trage den Kontoinhaber ein.'; }
      else if (!validIban(state.iban)) { key = 'iban'; message = 'Bitte prüfe deine IBAN. Länge oder Prüfziffer stimmen nicht.'; }
      else if (!state.consent) { key = 'consent'; message = 'Bitte bestätige das SEPA-Lastschriftmandat.'; }
      if (!key) return true;
      this.querySelector('[role="alert"]').textContent = message;
      this.fields[key].setCustomValidity(message);
      this.fields[key].focus();
      this.fields[key].reportValidity();
      return false;
    }
  }
  customElements.define('epk-cart-sepa', SepaCart);
  async function checkout(event, formId) {
    const panel = document.querySelector(`epk-cart-sepa[data-form="${formId}"]`);
    if (!panel) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || !panel.validate()) return;
    busy = true;
    panel.setAttribute('aria-busy', 'true');
    const buttons = [...document.querySelectorAll(`button[name="checkout"][form="${formId}"]`)];
    buttons.forEach(button => button.disabled = true);
    const enabled = state.enabled;
    const attributes = {
      'SEPA gewünscht': enabled ? 'Ja' : '',
      'SEPA Kontoinhaber': enabled ? state.holder.trim() : '',
      'SEPA IBAN': enabled ? normalize(state.iban) : '',
      'SEPA Mandat erteilt': enabled ? new Date().toISOString() : '',
      'SEPA Mandatstext': enabled ? panel.querySelector('[data-sepa-mandate]').textContent.trim() : '',
      'SEPA Zustimmung': enabled ? panel.querySelector('[data-sepa-consent-text]').textContent.trim() : ''
    };
    try {
      const root = window.Shopify?.routes?.root || '/';
      const note = document.getElementById(formId === 'cart' ? 'Cart-note' : 'CartDrawer-Note');
      const body = {attributes};
      if (note) body.note = note.value;
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      if (!cart.item_count) throw new Error('Empty cart');
      for (const [key, value] of Object.entries(attributes)) {
        if ((cart.attributes?.[key] || '') !== value) throw new Error('Attributes not saved');
      }
      window.location.assign(root + 'checkout');
    } catch (_) {
      panel.querySelector('[role="alert"]').textContent = 'Die Angaben konnten nicht gespeichert werden. Bitte versuche es noch einmal.';
      busy = false;
      buttons.forEach(button => button.disabled = false);
      panel.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"]');
    if (button && !button.disabled) checkout(event, button.form?.id || button.getAttribute('form'));
  }, true);
  document.addEventListener('submit', event => {
    if (['cart', 'CartDrawer-Form'].includes(event.target.id) && event.submitter?.name === 'checkout') checkout(event, event.target.id);
  }, true);
})();
